import type { TableQueryConfig } from "@/shared/lib/data-table/table-query"
import { FinanceTransactionStatusFilter } from "@/features/finance/model/finance-types"
import { LookupType } from "@/shared/model/lookup-types"

export const transactionsTableQueryConfig: TableQueryConfig = {
  id: "finance-transactions",
  search: {
    placeholderKey: "filters.searchPlaceholder",
    debounceMs: 300,
    className: "w-full max-w-sm",
  },
  defaultSortBy: "occurredAt",
  defaultSortOrder: "desc",
  defaultLimit: 20,
  defaultPage: 1,
  filters: [
    {
      id: "status",
      type: "select",
      key: "status",
      labelKey: "filters.status",
      // Default to Active so the list agrees with the overview KPIs (which count
      // only Active/posted transactions). "All statuses" reveals Cancelled/Voided.
      defaultValue: FinanceTransactionStatusFilter.Active,
      options: {
        type: "static",
        items: [
          { value: FinanceTransactionStatusFilter.All, labelKey: "filters.allStatuses" },
          { value: FinanceTransactionStatusFilter.Active, labelKey: "status.ACTIVE" },
          { value: FinanceTransactionStatusFilter.Cancelled, labelKey: "status.CANCELLED" },
          { value: FinanceTransactionStatusFilter.Voided, labelKey: "status.VOIDED" },
        ],
      },
    },
    {
      id: "occurredAt",
      type: "dateRange",
      labelKey: "filters.dateFrom",
      fromKey: "dateFrom",
      toKey: "dateTo",
      fromLabelKey: "filters.dateFrom",
      toLabelKey: "filters.dateTo",
      fromPlaceholderKey: "filters.dateFrom",
      toPlaceholderKey: "filters.dateTo",
    },
    {
      id: "incomeCategoryId",
      type: "asyncSelect",
      key: "incomeCategoryId",
      labelKey: "filters.incomeCategory",
      lookup: {
        type: LookupType.IncomeCategories,
        limit: 100,
        searchPlaceholderKey: "filters.incomeCategory",
        mobileEmptyKey: "filters.allIncomeCategories",
        loadingMessageKey: "filters.incomeCategory",
      },
    },
    {
      id: "expenseCategoryId",
      type: "asyncSelect",
      key: "expenseCategoryId",
      labelKey: "filters.expenseCategory",
      lookup: {
        type: LookupType.ExpenseCategories,
        limit: 100,
        searchPlaceholderKey: "filters.expenseCategory",
        mobileEmptyKey: "filters.allExpenseCategories",
        loadingMessageKey: "filters.expenseCategory",
      },
    },
    {
      id: "activityId",
      type: "asyncSelect",
      key: "activityId",
      labelKey: "filters.activity",
      lookup: {
        type: LookupType.Activities,
        limit: 100,
        activeOnly: false,
        searchPlaceholderKey: "filters.activity",
        mobileEmptyKey: "filters.allActivities",
        loadingMessageKey: "filters.activity",
      },
    },
    {
      id: "memberId",
      type: "asyncSelect",
      key: "memberId",
      labelKey: "filters.member",
      lookup: {
        type: LookupType.Members,
        limit: 10,
        searchPlaceholderKey: "filters.member",
        mobileEmptyKey: "filters.member",
        loadingMessageKey: "filters.member",
      },
    },
    {
      id: "groupId",
      type: "asyncSelect",
      key: "groupId",
      labelKey: "filters.group",
      lookup: {
        type: LookupType.Groups,
        limit: 100,
        activeOnly: false,
        searchPlaceholderKey: "filters.group",
        mobileEmptyKey: "filters.group",
        loadingMessageKey: "filters.group",
      },
    },
  ],
}
